<template>
  <div class="relative">
    <button class="flex items-center p-0.5 rounded-md transition-colors duration-100 flex-nowrap"
    :class="showDropdown ? 'bg-neutral-50' : 'bg-neutral-25 hover:bg-neutral-50'"
    @click="showDropdown = !showDropdown">
      <BaseText type="body" size="sm" class="text-text-normal px-2 py-0.5">
        {{ category.name }}
      </BaseText>
      <div class="h-3 w-0 mx-0.5 border-l border-border-hover" />
      <BaseText type="label" size="sm" class="text-text-muted px-2 py-0.5 text-left">
        {{ valuesText }}
      </BaseText>
      <button class="p-0.5 rounded-md transition-colors duration-100 hover:bg-neutral-100"
      @click.stop="$emit('remove')">
        <TagRemoveIcon stroke="#808899" />
      </button>
    </button>
    <transition>
      <div v-if="showDropdown" class="filter-item-dropdown" v-on-clickaway="() => { showDropdown = false }">
        <FilterSelectDropdown 
          :active-filters="activeFilters"
          :locked-category-id="category.id"
          @applyFilters="applyFilterChanges($event)"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway2'
import { getValuesText } from '@/utils/filterUtils'

// Components
import FilterSelectDropdown from '../FilterSelectDropdown.vue'

// Icons
import TagRemoveIcon from '../../globals/Icons/TagRemoveIcon.vue'

export default {
  name: 'FilterItem',
  mixins: [clickaway],
  components: {
    FilterSelectDropdown,
    TagRemoveIcon
  },
  props: {
    category: {
      type: Object,
      required: true
    },
    values: {
      type: Array,
      required: true
    },
    activeFilters: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showDropdown: false
    }
  },
  computed: {
    valuesText () {
      return getValuesText(this.values, this.category)
    }
  },
  methods: {
    applyFilterChanges (filters) {
      this.$emit('applyFilters', filters)
      this.showDropdown = false
    }
  }
}
</script>

<style scoped>
.filter-item-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 500;
}

.v-enter-active, .v-leave-active {
  transition: opacity 150ms ease-in-out;
}
.v-enter-from, .v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave-from {
  opacity: 1;
}
</style>